import Vue from 'vue';
let connect = new Vue();
export default connect;